import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 锁单列表查询
export function queryLockList(data) {
  return request({
    url: URL.creditBusinessManage.queryLockList,
    method: 'post',
    data
  })
}
// 信控情况
export function queryCreditInfo(params) {
  return request({
    url: URL.creditBusinessManage.queryCreditInfo,
    method: 'post',
    params
  })
}

// 特批
export function specialApproval(params) {
  return request({
    url: URL.creditBusinessManage.specialApproval,
    method: 'post',
    params
  })
}
// 特批列表查询
export function querySpecialApprovalList(data) {
  return request({
    url: URL.creditBusinessManage.querySpecialApprovalList,
    method: 'post',
    data
  })
}
// 取消特批
export function cancelSpecialApproval(params) {
  return request({
    url: URL.creditBusinessManage.cancelSpecialApproval,
    method: 'post',
    params
  })
}
// 信控日志列表查询
export function queryCreditLogList(data) {
  return request({
    url: URL.creditBusinessManage.queryCreditLogList,
    method: 'post',
    data
  })
}
// 获取超信控应收费用结算对象（锁定）
export function queryLockOverCreditAccountIds(params) {
  return request({
    url: URL.creditBusinessManage.queryLockOverCreditAccountIds,
    method: 'get',
    params
  })
}
// 获取超信控应收费用结算对象（特批）
export function querySpecialOverCreditAccountIds(params) {
  return request({
    url: URL.creditBusinessManage.querySpecialOverCreditAccountIds,
    method: 'get',
    params
  })
}
// 获取超信控应收费用结算对象（日志）
export function queryLogOverCreditAccountIds(params) {
  return request({
    url: URL.creditBusinessManage.queryLogOverCreditAccountIds,
    method: 'get',
    params
  })
}
